// src/components/Header.js

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { DiscordLink } from './DiscordButton';
import './Header.css';

const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const headerRef = useRef(null);
  const expandedRef = useRef(false);

  // The contact bar wraps onto two or three lines on narrow screens, so the
  // space the page needs to leave for the fixed header isn't a fixed number.
  // Publish the real height as --header-h and let App.css pad with it.
  const measure = useCallback(() => {
    const el = headerRef.current;
    if (!el || expandedRef.current) return; // ignore the open mobile menu
    const h = Math.round(el.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--header-h', `${h}px`);
  }, []);

  useEffect(() => {
    measure();
    const ro = new ResizeObserver(measure);
    if (headerRef.current) ro.observe(headerRef.current);
    window.addEventListener('resize', measure);
    window.addEventListener('orientationchange', measure);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measure);
      window.removeEventListener('orientationchange', measure);
    };
  }, [measure]);

  useEffect(() => {
    expandedRef.current = expanded;
    if (!expanded) measure();
  }, [expanded, measure]);

  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <div className="site-header" ref={headerRef}>
      <Navbar bg="dark" variant="dark" expand="lg" expanded={expanded} onToggle={setExpanded}>
        <Container>
          <Navbar.Brand as={Link} to="/" onClick={handleNavClick}>Capital Pinball Parlor</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/" onClick={handleNavClick}>Home</Nav.Link>
              <Nav.Link as={Link} to="/about" onClick={handleNavClick}>About</Nav.Link>
              <Nav.Link as={Link} to="/membership" onClick={handleNavClick}>Membership</Nav.Link>
              <Nav.Link as={Link} to="/games" onClick={handleNavClick}>Games</Nav.Link>
              <Nav.Link as={Link} to="/tournaments" onClick={handleNavClick}>Tournaments</Nav.Link>
              <Nav.Link as={Link} to="/leaderboards" onClick={handleNavClick}>Leaderboards</Nav.Link>
              <Nav.Link as={Link} to="/alerts" onClick={handleNavClick}>Alerts</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <div className="contact-bar">
        <Container>
          <div className="contact-bar__inner">
            <span className="contact-bar__item">
              <span aria-hidden="true">📍</span>
              <a
                className="contact-bar__map"
                href="https://maps.google.com/?q=117+J+St,+Sacramento,+CA+95814"
                target="_blank"
                rel="noopener noreferrer"
              >
                117 J St, Old Sacramento, CA 95814
              </a>
            </span>
            <span className="contact-bar__item">
              <span aria-hidden="true">📞</span>
              <a href="tel:+19169139170" className="contact-bar__phone">(916) 913-9170</a>
            </span>
            <span className="contact-bar__item">
              <DiscordLink />
            </span>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Header;
